module.exports = __webpack_public_path__ + "ProximaNova-Semibold.7fd24e723090d63c6453a12d4db6cdc6.woff";